import { AreaChartColors, QueueChartColors, QueueGaugeChartColors } from '@/enum/colors'
import { getActiveLayoutColors } from '@/composables/globalData/useLayouts'
import { defaultQueueColors } from '@/helpers/multiQueueDashboardRedesign'

export const REAL_TIME_WIDGET_CARDS_COLUMN_MODE = {
    STATIC: 'static',
    AUTO: 'auto'
}

export const REAL_TIME_WIDGET_CARDS_COLUMN_SIZE = {
    AUTO: 'auto',
    EXTRA_SMALL: 'extra-small',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
}

export const realTimeSettings = {
    showLoggedOutUsers: false,
    showRecentlyLoggedOut: false,
    recentlyLoggedOutMaxDuration: 0,
    showLoggedOutUsersTime: false,
    generalThreshold: false,
    generalThresholdLowValue: 0,
    generalThresholdHeightValue: 0,
    callThreshold: false,
    callThresholdLowValue: 10,
    callThresholdHeightValue: 0,
    resetIdleTime: false,
    resetStatusTimeOnCallUpdate: false,
    showStatusTagWhenOnCall: false,
    showTotalCallsSummary: false,
    positivePerformanceThreshold: 60,
    agentNameFontSize: 16,
    timerFontSize: 30,
    callInfoFontSize: 16,
    hideStatistics: false,
    /* static | auto */
    columnsMode: REAL_TIME_WIDGET_CARDS_COLUMN_MODE.STATIC,
    columnsSize: REAL_TIME_WIDGET_CARDS_COLUMN_SIZE.MEDIUM,
}

export function getAllDefaultCardColors () {

    const {
        colorWidgetBorder,
        colorWidgetBackground,
        mainTextColor,
        colorWidgetHeaderText
    } = getActiveLayoutColors()
    return {
        background: colorWidgetBackground,
        frames: colorWidgetBorder,
        fonts: mainTextColor,
        widgetHeader: colorWidgetHeaderText
    }
}

export function defaultAreaChartColors () {
    return {
        ...getAllDefaultCardColors(),
        outgoing: AreaChartColors.outgoing,
        incoming: AreaChartColors.incoming,
    }
}

export const defaultQueueGaugeChartColors = () => ({
    ...getAllDefaultCardColors(),
    minimumRangeColor: QueueGaugeChartColors.minimumRangeColor,
    middleRangeColor: QueueGaugeChartColors.middleRangeColor,
    maximumRangeColor: QueueGaugeChartColors.maximumRangeColor
})

export const defaultQueueChartColors = () => ({
    ...getAllDefaultCardColors(),
    queueCalls: QueueChartColors.queueCalls,
    maxWaitingTime: QueueChartColors.maxWaitingTime
})

export const defaultMultiQueuesDashboardColors = () => ({
    ...getAllDefaultCardColors(),
    ...defaultQueueColors
})
